<template>
	<div class="container">
		<el-input placeholder="输入关键字进行过滤" v-model="filterText" size="small" style="width: 100%" clearable>
		</el-input>
		<div class="scrollDiv">
			<el-scrollbar style="height: 100%">
				<el-tree id="treeMenu" ref="treeMenu" :data="nodeData" :filter-node-method="filterNode"
					class="filter-tree" current-node-key="2" node-key="key" :default-expanded-keys="defaultExpandKeys"
					:highlight-current="true" @node-click="treeMenuClick" :show-checkbox="showCheckBox" :indent="10">
					<span class="custom-tree-node" slot-scope="{ node, data }">
						<span v-if="data.children" class="iconfont icon-chejiandayin">
						</span>
						<span v-else class="icon-dianji iconfont" style="margin-right: 3px"></span>
						<span @mouseover="treeNodeMouseHover" @mouseout="treeNodeMouseLeave"
							style="width: 100%">{{ node.label }}</span>
					</span>
				</el-tree>
			</el-scrollbar>
		</div>
	</div>
</template>

<script>
	import {
		selectLesseeTreeData
	} from '../../api/property/controlManage';

	export default {
		props: ['showCheckBox'],
		data() {
			return {
				nodeId: '',
				nodeName: '',
				nodeFlag: false,
				nodeData: [],
				treeNodeFontColor: '',
				filterText: '',
				defaultExpandKeys: ['1'],
			};
		},
		created() {
			this.init();
		},

		mounted() {},

		watch: {
			filterText(val) {
				this.$refs.treeMenu.filter(val);
			},
		},

		methods: {
			async init() {
				await this.getNodeData();
			},
			treeNodeMouseHover(event) {
				// alert(event.target.innerHTML);
				if (this.treeNodeFontColor == '') {
					this.treeNodeFontColor = event.target.style.color;
				}
				event.target.style.color = '#409eff';
			},
			treeNodeMouseLeave(event) {
				event.target.style.color = this.treeNodeFontColor;
			},
			treeMenuClick(treeNodeObject) {
				if (treeNodeObject.nodeFlag) {
					this.nodeId = treeNodeObject.nodeId;
					this.nodeName = treeNodeObject.nodeName;
					this.nodeFlag = treeNodeObject.nodeFlag;
					this.$emit('treeMenuClick');
				}
			},

			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},

			async getNodeData() {
				const response = await selectLesseeTreeData().then();
				this.nodeData = response.data;
				this.nodeId = this.nodeData[0].children[0].nodeId;
				this.nodeName = this.nodeData[0].children[0].nodeName;
				this.nodeFlag = this.nodeData[0].children[0].nodeFlag;
				this.$emit('loadFinish');
			},

			getCheckedNodes() {
				return this.$refs.treeMenu.getCheckedNodes();
			},
		},
	};
</script>

<style scoped lang="scss">
	.el-tree {
		min-width: fit-content;
		width: 100%;
		height: 100%;
		// background: transparent;
		overflow-x: auto !important;
		font-size: 14px;
	}

	/deep/ .el-scrollbar__wrap {
		overflow-x: auto !important;
		overflow: scroll;
	}

	/deep/ .el-scrollbar__view {
		height: 100%;
		width: 100%;
	}

	.scrollDiv {
		height: calc(100vh - 320px);
	}

	.container {
		width: 100%;
	}

	.el-tree-node__content {
		width: 100%;
	}
</style>
